<template>
    <div>
        <div class="price-adjustment-setting">
            <div class="row w-100">
                <div class="col-md-7">
                    <div>Product*</div>
                    <div>
                        <ProductSearchInput :defaultProductId="defaultProductId" ref="searchInput" @change="selectedProduct = $event" />
                    </div>
                </div>
                <div class="col-md-5">
                    <div>Location*</div>
                    <div>
                        <SelectDropdown
                            v-if="warehouses && warehouses.length"
                            :options="warehouseOptions"
                            :value="selectedWarehouse"
                            @change="selectedWarehouse = $event"
                        />
                        <div class="text-secondary mt-1" v-else>No Warehouses Found</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-3">
            <Button :disabled="!allowAddProduct" noMargin @click="addProduct">Add Product</Button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import SelectDropdown from "../crud/SelectDropdown.vue";
import Button from "../UI/Button.vue";
import ProductSearchInput from "./ProductSearchInput.vue";
import PriceFetchApi from "../../utils/fetch/price-fetch-api";

export default {
    data() {
        return {
            selectedProduct: null,
            selectedWarehouse: null,
            warehousePrice: null
        };
    },
    components: { Button, SelectDropdown, ProductSearchInput },
    computed: {
        ...mapState("misc", ["warehouses"]),
        allowAddProduct() {
            return this.selectedProduct && this.selectedProduct.id && this.selectedWarehouse;
        },
        warehouseOptions() {
            return this.warehouses.map(warehouse => ({
                id: warehouse.id,
                title: warehouse.name
            }));
        }
    },
    methods: {
        async getWarehouseSpecificPrice(itemCode, warehouseId) {
            try {
                const response = await PriceFetchApi.getWarehouseSpecificPrice(itemCode, warehouseId);
                // Extract the regular price from the API response
                const regularPrice = response.result.regularPrice ? 
                    Number(response.result.regularPrice.price_list_rate) : 
                    (this.selectedProduct.selling_price || 0);
                    
                return regularPrice;
            } catch (err) {
                console.error("Error fetching warehouse-specific price:", err);
                return this.selectedProduct.selling_price || 0;
            }
        },
        async addProduct() {
            if (!this.selectedProduct || !this.selectedProduct.id) {
                return this.$toast.error("Please select a product to add!");
            }

            if (!this.selectedWarehouse) {
                return this.$toast.error("Please select a warehouse!");
            }
            
            // Get warehouse-specific price using item_code
            const warehousePrice = await this.getWarehouseSpecificPrice(
                this.selectedProduct.item_code, 
                this.selectedWarehouse
            );
            
            const selectedWarehouseObj = this.warehouseOptions.find(w => w.id === this.selectedWarehouse);
            
            this.$emit("add", {
                ...this.selectedProduct,
                warehouse_id: this.selectedWarehouse,
                warehouse_name: selectedWarehouseObj ? selectedWarehouseObj.title : "",
                current_price: warehousePrice,
                new_price: warehousePrice
            });
            
            this.selectedProduct = null;
            this.$refs.searchInput.clear();
            this.$toast.success("Product added for price adjustment!");
        }
    },
    props: {
        addedProducts: { type: Array, default: () => [] },
        defaultProductId: { type: String, default: "" }
    },
    watch: {
        selectedProduct() {
            // Reset the warehouse price when product changes
            this.warehousePrice = null;
        }
    }
};
</script>

<style>
.price-adjustment-setting {
    display: flex;
    width: 100%;
    align-items: center;
    gap: 15px;
}
</style>
